import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useEyeconxStore } from '../../../../../store/eyeconxStore';
import settingsService from '../../../../../services/settings.service';

const RecallCard = ({ title, backgroundColor = null, icon, limit = 0, variant = "primary" }) => {
    // Color variants for different card styles
    const variants = {
        primary: { bg: "bg-primary", text: "text-white", iconBg: "bg-white bg-opacity-20" },
        success: { bg: "bg-success", text: "text-white", iconBg: "bg-white bg-opacity-20" },
        info: { bg: "bg-info", text: "text-white", iconBg: "bg-white bg-opacity-20" },
        warning: { bg: "bg-warning", text: "text-dark", iconBg: "bg-dark bg-opacity-10" },
        danger: { bg: "bg-danger", text: "text-white", iconBg: "bg-white bg-opacity-20" },
        light: { bg: "bg-light", text: "text-dark", iconBg: "bg-dark bg-opacity-10" },
        dark: { bg: "bg-dark", text: "text-white", iconBg: "bg-white bg-opacity-20" }
    };

    const currentVariant = variants[variant] || variants.primary;

    return (
        <div className={`card ${backgroundColor || currentVariant.bg} ${currentVariant.text} shadow-sm border-0 h-100 transition-all`}
             style={{ transition: 'all 0.3s ease' }}>
            <div className="card-body">
                <div className="d-flex justify-content-between  align-items-center">
                    {/* Icon Section */}
                    <div className={`rounded-circle p-3 ${currentVariant.iconBg} me-5 d-flex align-items-center justify-content-center`}
                         style={{ width: '60px', height: '60px' }}>
                        <i className={`bi ${icon} fs-1`}></i>
                    </div>

                    {/* Content Section */}
                    <div className="flex-grow-1">
                        <h6 className={`card-title mb-1 opacity-75 fw-normal text-uppercase small ${currentVariant.text}`}>
                            {title}
                        </h6>
                        <h3 className={`mb-0 fw-bold display-6 ${currentVariant.text}`}>
                            {limit.toLocaleString()}
                        </h3>
                    </div>
                </div>
            </div>
        </div>
    );
};
const RecallMediumDisplay = ({ mediumValue }) => {
    const recallMediums = [
        { value: 'EMAIL', label: 'Email', icon: 'bi-envelope-fill', color: 'text-primary' },
        { value: 'SMS', label: 'SMS', icon: 'bi-chat-text-fill', color: 'text-success' },
        { value: 'CALL', label: 'Phone Call', icon: 'bi-telephone-fill', color: 'text-info' }
    ];

    // Find the medium object based on the value
    const currentMedium = recallMediums.find(m => m.value === mediumValue) || recallMediums[0];

    return (
        <div className="text-center p-2 bg-light rounded">
            <i className={`bi ${currentMedium.icon} ${currentMedium.color} fs-4 d-block mb-1`}></i>
            <small className="text-muted d-block">Medium</small>
            <span className="fw-semibold text-dark">{currentMedium.label}</span>
        </div>
    );
};
const RecallSettings = () => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(false);
    const clinicId = useEyeconxStore((state) => state.user.clinicId);




    const fetchRecallSettings = async () => {
        setLoading(true);
        try {
            const response = await settingsService.getRecallSettings(clinicId);
            setSettings(response.data);
        } catch (error) {
            console.error('Error fetching recall settings:', error);
        } finally {
            setLoading(false);
        }
    };



    useEffect(() => {
        fetchRecallSettings();
    }, []);

    const recallMediums = [
        { value: 'EMAIL', label: 'Email', icon: 'bi-envelope' },
        { value: 'SMS', label: 'SMS', icon: 'bi-chat-text' },
        { value: 'CALL', label: 'Phone Call', icon: 'bi-telephone' }
    ];
    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p className="text-muted mt-2">Loading recall settings...</p>
            </div>
        );
    }

    return (
       <>
            <div className="row mt-3">
                <div className="col-12">
                    <div className="card bg-light shadow-sm border-0 h-100">
                        <div className="card-header bg-transparent border-0 pb-0">
                            <div className="card-title">

                                <i className="bi bi-bell-fill me-2"></i>
                                Daily Recall Limit
                            </div>
                            <div className="card-body">
                                    <div className="row">
                                        <div className="col-4">
                                                <RecallCard
                                                    title="Email"
                                                    icon="bi-envelope"
                                                    limit={settings?.emailLimitPerDay}
                                                />
                                        </div>
                                        <div className="col-4">
                                            <RecallCard
                                                title="Sms"
                                                icon="bi-envelope"
                                                limit={settings?.smsLimitPerDay}
                                                variant="success"
                                            />
                                        </div>
                                        <div className="col-4">
                                            <RecallCard
                                                title="Call"
                                                icon="bi-envelope"
                                                limit={settings?.callLimitPerDay}
                                                variant="info"
                                            />
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

           {/* Second, Third & Fourth */}

           <div className="row mt-3">
               <div className="col-12">
                   <div className="card bg-light shadow-sm border-0 h-100">
                       <div className="card-header bg-transparent border-0 pb-0">
                           <div className="card-title">
                               <i className="bi bi-diagram-3 me-2"></i>
                               Recall Sequence Configuration
                           </div>
                           <div className="card-body">


                               <div className="col-12">
                                   <div className="card border-0 shadow-sm h-100">
                                       <div className="card-body">
                                           <div className="d-flex justify-content-between align-items-start">
                                               {/* Left Content */}
                                               <div className="flex-grow-1">
                                                   <div className="d-flex align-items-center mb-2">
                                                       <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                                                           <i className="bi bi-arrow-repeat text-primary fs-5"></i>
                                                       </div>
                                                       <div>
                                                           <h5 className="card-title mb-0 text-dark">Second Recall</h5>
                                                           <p className="text-muted mb-0 small">Recall after first recall</p>
                                                       </div>
                                                   </div>
                                               </div>

                                               {/* Right Status Badge */}

                                                   {settings?.isSecondRecall? <>
                                                   <div className="bg-success bg-opacity-10 text-success rounded-pill px-3 py-1">
                                                       <i className="bi bi-check-circle-fill me-1 small"></i>
                                                       Enabled
                                                   </div>
                                                   </>:<>
                                                       <div className="bg-danger bg-opacity-10 text-danger rounded-pill px-3 py-1">
                                                           <i className="bi bi-x-circle-fill me-1 small"></i>
                                                           Disabled
                                                       </div>
                                                   </>}


                                           </div>

                                           {/* Configuration Details */}
                                           <div className="row g-3 mt-3 pt-3 border-top">
                                               <div className="col-6">
                                                   <RecallMediumDisplay mediumValue={settings?.secondRecallMedium} />
                                               </div>
                                               <div className="col-6">
                                                   <div className="text-center p-2 bg-light rounded">
                                                       <i className="bi bi-calendar-week text-info fs-4 d-block mb-1"></i>
                                                       <small className="text-muted d-block">Wait Period</small>
                                                       <span className="fw-semibold text-dark">{settings?.secondRecallWaitPeriod} days</span>
                                                   </div>
                                               </div>
                                           </div>


                                       </div>
                                   </div>
                               </div>
                               {/* Third Recall */}
                               <div className="col-12">
                                   <div className="card border-0 shadow-sm h-100">
                                       <div className="card-body">
                                           <div className="d-flex justify-content-between align-items-start">
                                               {/* Left Content */}
                                               <div className="flex-grow-1">
                                                   <div className="d-flex align-items-center mb-2">
                                                       <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                                                           <i className="bi bi-arrow-repeat text-primary fs-5"></i>
                                                       </div>
                                                       <div>
                                                           <h5 className="card-title mb-0 text-dark">Third Recall</h5>
                                                           <p className="text-muted mb-0 small">Recall after first recall</p>
                                                       </div>
                                                   </div>
                                               </div>

                                               {/* Right Status Badge */}
                                               {settings?.isThirdRecall? <>
                                                   <div className="bg-success bg-opacity-10 text-success rounded-pill px-3 py-1">
                                                       <i className="bi bi-check-circle-fill me-1 small"></i>
                                                       Enabled
                                                   </div>
                                               </>:<>
                                                   <div className="bg-danger bg-opacity-10 text-danger rounded-pill px-3 py-1">
                                                       <i className="bi bi-x-circle-fill me-1 small"></i>
                                                       Disabled
                                                   </div>
                                               </>}
                                           </div>

                                           {/* Configuration Details */}
                                           <div className="row g-3 mt-3 pt-3 border-top">
                                               <div className="col-6">
                                                   <RecallMediumDisplay mediumValue={settings?.thirdRecallMedium} />

                                               </div>
                                               <div className="col-6">
                                                   <div className="text-center p-2 bg-light rounded">
                                                       <i className="bi bi-calendar-week text-info fs-4 d-block mb-1"></i>
                                                       <small className="text-muted d-block">Wait Period</small>
                                                       <span className="fw-semibold text-dark">{settings?.thirdRecallWaitPeriod} days</span>
                                                   </div>
                                               </div>
                                           </div>


                                       </div>
                                   </div>
                               </div>

                               {/* Fourth Recall */}
                               <div className="col-12">
                                   <div className="card border-0 shadow-sm h-100">
                                       <div className="card-body">
                                           <div className="d-flex justify-content-between align-items-start">
                                               {/* Left Content */}
                                               <div className="flex-grow-1">
                                                   <div className="d-flex align-items-center mb-2">
                                                       <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
                                                           <i className="bi bi-arrow-repeat text-primary fs-5"></i>
                                                       </div>
                                                       <div>
                                                           <h5 className="card-title mb-0 text-dark">Fourth Recall</h5>
                                                           <p className="text-muted mb-0 small">Recall after third recall</p>
                                                       </div>
                                                   </div>
                                               </div>

                                               {/* Right Status Badge */}
                                               {settings?.isFourthRecall? <>
                                                   <div className="bg-success bg-opacity-10 text-success rounded-pill px-3 py-1">
                                                       <i className="bi bi-check-circle-fill me-1 small"></i>
                                                       Enabled
                                                   </div>
                                               </>:<>
                                                   <div className="bg-danger bg-opacity-10 text-danger rounded-pill px-3 py-1">
                                                       <i className="bi bi-x-circle-fill me-1 small"></i>
                                                       Disabled
                                                   </div>
                                               </>}
                                           </div>

                                           {/* Configuration Details */}
                                           <div className="row g-3 mt-3 pt-3 border-top">
                                               <div className="col-6">
                                                   <RecallMediumDisplay mediumValue={settings?.fourthRecallMedium} />

                                               </div>
                                               <div className="col-6">
                                                   <div className="text-center p-2 bg-light rounded">
                                                       <i className="bi bi-calendar-week text-info fs-4 d-block mb-1"></i>
                                                       <small className="text-muted d-block">Wait Period</small>
                                                       <span className="fw-semibold text-dark">{settings?.fourthRecallWaitPeriod} days</span>
                                                   </div>
                                               </div>
                                           </div>


                                       </div>
                                   </div>
                               </div>

                           </div>

                       </div>
                   </div>
               </div>
           </div>
       </>
    );
};

export default RecallSettings;